import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('intFile', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SET_FILTERS',
    'GET_FILE_LOG'
]);
export const initialPropConfigState = {
    ...generateDefaultState('intFile', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SET_FILTERS',
        'GET_FILE_LOG'
    ]),
};
